import { lazy, Suspense } from 'react';

import { type TenantResponse } from '@/cloud/types/router';
import { isCloud, isMultiTenant } from '@/consts/env';

import SelfHostedCreateTenantModal from './SelfHostedCreateTenantModal';

const CloudCreateTenantModal = lazy(async () => import('./CloudCreateTenantModal'));

type Props = {
  readonly isOpen: boolean;
  readonly onClose: (tenant?: TenantResponse) => void;
};

function CreateTenantModal(props: Props) {
  if (isMultiTenant && !isCloud) {
    return <SelfHostedCreateTenantModal {...props} />;
  }

  return (
    <Suspense fallback={null}>
      <CloudCreateTenantModal {...props} />
    </Suspense>
  );
}

export default CreateTenantModal;
